import { render, staticRenderFns } from "./rightPage.vue?vue&type=template&id=39cef590"
import script from "./rightPage.vue?vue&type=script&lang=js"
export * from "./rightPage.vue?vue&type=script&lang=js"
import style0 from "./rightPage.vue?vue&type=style&index=0&id=39cef590&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports